//src/app/features/dashboard/VideosSection.tsx
import React from 'react';
import YoutubeEmbed from './shared/YoutubeEmbed';

const videos = [
  'ESBRhtEzTkE', // #1
  'bSWP--lmUs4', // #2
  '_urQ4hU2si4', // #3 (new)
];

export default function VideosSection() {
  return (
    <section className="border border-gray-100 rounded-md w-full h-full flex flex-col overflow-hidden">
      {/* ── header ──────────────────────────────────────── */}
      <header className="h-[55px] border-b border-gray-100 bg-white p-2 flex items-center text-sm font-semibold text-gray-dark">
        Get&nbsp;Started
      </header>

      {/* ── video grid ──────────────────────────────────── */}
      <div className="bg-black overflow-auto p-4">
        {' '}
        {/* ← no flex-1, no fixed height */}
        <div
          className="
      grid gap-4
      grid-cols-1 sm:grid-cols-2 lg:grid-cols-3
      auto-rows-max           /* rows hug their content           */
      items-start             /* don’t stretch grid children      */
    "
        >
          {videos.map((id) => (
            <div
              key={id}
              className="w-full border border-gray-300 rounded-md overflow-hidden bg-black shadow-sm hover:shadow-md transition-shadow"
            >
              <YoutubeEmbed embedId={id} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
